<template>
  <o-dialog
    ref="dialog"
    :title="$t('components.purchaseOrder.actions.remove.title')"
    :info="info"
    :options="[
      { text: $t('general.cancel'), type: 'cancel' },
      { text: $t('general.confirm'), type: 'confirm', variant: 'danger', callback: confirm },
    ]"
    :portal="portal"
  />
</template>

<script setup lang="ts">
import type { PurchaseOrder, PurchaseOrderItem } from '~/_api/models/purchaseOrder'

interface Props {
  purchaseOrder: PurchaseOrder
  portal?: string
  loading?: boolean
}

interface Emits {
  (e: 'update:loading', value: boolean): void
  (e: 'success'): void
  (e: 'error'): void
}

const props = withDefaults(defineProps<Props>(), {
  portal: undefined,
  loading: false,
})

const emit = defineEmits<Emits>()
const { $api, $i18n, $notification } = useNuxtApp()

const dialog = ref<any>()
const purchaseOrderItem = ref<PurchaseOrderItem | null>(null)

const info = computed(() => {
  return $i18n.t('components.purchaseOrder.actions.remove.info', { title: purchaseOrderItem.value?.title, id: purchaseOrderItem.value?.idPurchaseOrderItem })
})

const open = (item: PurchaseOrderItem) => {
  purchaseOrderItem.value = item
  dialog.value.open()
}

const confirm = async () => {
  if (!purchaseOrderItem.value) return

  emit('update:loading', true)

  try {
    const response = await $api.purchaseOrder.removeItem(props.purchaseOrder, purchaseOrderItem.value)

    if (response.success) {
      $notification.toast({
        title: $i18n.t('purchaseOrder.saved'),
        text: $i18n.t('components.purchaseOrder.actions.remove.successInfo', { title: purchaseOrderItem.value.title }),
      })

      emit('success')

      return true
    }

    return false
  } catch (e: any) {
    $notification.error({ errors: e?.errors })
    emit('error')
    return false
  } finally {
    emit('update:loading', false)
  }
}

defineExpose({
  open,
})
</script>
